// Firebase/GA4 hard limits: event names <= 40 chars, param names <= 40,
// string param values <= 100, max 25 params per event. Names over 40 chars
// arrive truncated in BigQuery (see aiball_app#288). Enforced at runtime by
// AnalyticsService and at build time by scripts/check-analytics-slugs.js.
export enum AnalyticsSlugs {
  SCREEN_VIEW = "aiball_screen_view",
  ACQUISITION_LOGIN = "aiball_login",
  ACQUISITION_REGISTER = "aiball_register",
  ACQUISITION_LOGOUT = "aiball_logout",
  ACQUISITION_COMPLETE_PROFILE = "aiball_complete_profile",
  ACQUISITION_CLICK_BUTTON_DELETE_ACCOUNT = "aiball_click_button_delete_account",
  ACQUISITION_SELECT_DIALOG_DELETE_ACCOUNT = "aiball_select_dialog_delete_account",
  HOME_USE_FILTERS = "aiball_home_use_filters",
  STATS_CLICK_INFO_BUTTON = "aiball_stats_click_info_button",
  MATCHES_MATCHES_LIST_USE_FILTERS = "aiball_matches_list_use_filters",
  MATCHES_MATCHES_CLICK_MATCH = "aiball_matches_click_match",
  MATCHES_MATCH_IDENTIFICATION_MISSING_IDENTIFY = "aiball_match_ident_missing_identify",
  MATCHES_MATCH_IDENTIFICATION_MISSING_SELECT_MATCH_RESULT = "aiball_match_ident_select_result",
  MATCHES_MATCH_DETAIL_PLAY_VIDEO = "aiball_match_detail_play_video",
  MATCHES_MATCH_DETAIL_PAUSE_VIDEO = "aiball_match_detail_pause_video",
  MATCHES_MATCH_DETAIL_OPEN_HORIZONTAL_VIDEO = "aiball_match_open_horizontal_video",
  MATCHES_MATCH_DETAIL_OPEN_VERTICAL_VIDEO = "aiball_match_open_vertical_video",
  MATCHES_MATCH_DETAIL_SHARE_HORIZONTAL_VIDEO = "aiball_match_share_horizontal_video",
  MATCHES_MATCH_DETAIL_SHARE_VERTICAL_VIDEO = "aiball_match_share_vertical_video",
  MATCHES_MATCH_DETAIL_SHARE_VERTICAL_VIDEO_INSTAGRAM = "aiball_match_share_vertical_instagram",
  MATCHES_MATCH_DETAIL_CONTACT_COACH = "aiball_match_detail_contact_coach",
  MATCHES_MATCH_DETAIL_VIDEO_LOAD_ERROR = "aiball_match_detail_video_load_error",

  MATCHES_MATCH_DETAIL_DOWNLOAD_INFOGRAPHIC = "aiball_match_detail_download_infographic",
  BOOKING_LIST_BOOKING_CLICK_ADD_BUTTON = "aiball_list_booking_click_add_button",
  BOOKING_LIST_BOOKING_DIALOG_MISSING_INFORMATION_CHOOSE_OPTION = "aiball_booking_missing_info_dialog",
  BOOKING_BOOK_MATCH = "aiball_book_match",
  BOOKING_BOOK_MATCH_ERROR = "aiball_book_match_error",

  BOOKING_CLICK_EDIT_BOOK_BUTTON = "aiball_booking_click_edit_button",
  BOOKING_EDIT_BOOKING = "aiball_booking_edit_booking",
  BOOKING_EDIT_BOOKING_ERROR = "aiball_booking_edit_booking_error",
  BOOKING_CLICK_CANCEL_BOOKING_BUTTON = "aiball_booking_click_cancel_button",
  BOOKING_DISCARD_CANCEL_BOOKING_DIALOG = "aiball_booking_discard_cancel_dialog",
  BOOKING_DISCARD_LEAVE_BOOKING_DIALOG = "aiball_booking_discard_leave_dialog",
  BOOKING_CANCEL_BOOKING = "aiball_cancel_booking",
  BOOKING_LEAVE_BOOKING = "aiball_leave_booking",
  BOOKING_INVITE_FRIENDS = "aiball_booking_invite_friends",
  BOOKING_JOIN_MATCH = "aiball_booking_join_match",
  BOOKING_LEAVE_MATCH = "aiball_booking_leave_match",
  AIBALL_EDIT_PROFILE = "aiball_edit_profile",
  AIBALL_CONTACT_WITH_US = "aiball_contact_with_us",
  AIBALL_CLICK_RESET_PASSWORD_DIALOG = "aiball_click_reset_password_dialog",
  AIBALL_SELECT_RESET_PASSWORD_DIALOG = "aiball_select_reset_password_dialog",
  CHAT_OPEN = "aiball_chat_open",
  CHAT_SEND_MESSAGE = "aiball_chat_send_message",
  CHAT_RESPONSE = "aiball_chat_response",
  CHAT_ERROR = "aiball_chat_error",
  COMMUNITY_MODE = "aiball_community_mode",
  COMMUNITY_OPEN_CLUB = "aiball_community_open_club",
  COMMUNITY_PROMO_CTA = "aiball_community_promo_cta",
  CLUB_CONTACT = "aiball_club_contact",
  CLUB_FAVORITE = "aiball_club_favorite",
  CLUB_BOOK_COURT = "aiball_club_book_court",
}
